import { inject } from "fw";
import { wait } from "wait";

import { Manager, EntitySelection } from "./manager";
import { CasProgramIntegration, CasProgramIntegrationPostBulkArgs, CasProgramIntegrationClientModel } from "models/cas-program-integration";

@inject
export class CasProgramIntegrationRepository {
    constructor(private s: Manager) {}

    async post(integration: CasProgramIntegration, casOrganizationIntegrationId: string) {
        const res = await this.s.post<CasProgramIntegration>("cas-program-integration", integration, { casOrganizationIntegrationId });
        await wait(1000);
        return res.body;
    }

    async postBulk(args: CasProgramIntegrationPostBulkArgs) {
        const res = await this.s.post<number>("cas-program-integration/bulk", args);
        await wait(1000);
        return res.body;
    }

    async searchClientModels(
        casOrganizationIntegrationId: string,
        search: string,
        filter: string = null,
        sort: string = null,
        pageSize: number = null,
        previousPageToken: string = null,
        nextPageToken: string = null,
        fields: string = null
    ) {
        const res = await this.s.get<CasProgramIntegrationClientModel[]>("cas-program-integration/client-models", {
            casOrganizationIntegrationId,
            s: search,
            f: filter,
            sort,
            pageSize,
            previousPageToken,
            nextPageToken,
            fields
        });
        return {
            list: res.body,
            total: parseInt(res.headers["x-manager-total"], 10),
            previousPageToken: res.headers["x-manager-previous-page-token"],
            nextPageToken: res.headers["x-manager-next-page-token"]
        };
    }

    async availableCasProgramIds(casOrganizationIntegrationId: string, filter: string = null, page = 1, pageSize = 20) {
        const res = await this.s.get<number[]>("cas-program-integration/available-cas-programs", { casOrganizationIntegrationId, filter, page, pageSize });
        return {
            result: res.body,
            total: parseInt(res.headers["x-manager-total"], 10)
        };
    }

    async delete(id: string) {
        await this.s.delete(`cas-program-integration/${id}`);
        await wait(1000);
    }

    async deleteSelection(selection: EntitySelection, casOrganizationIntegrationId: string, selectAll: boolean = false) {
        const res = await this.s.post<number>("cas-program-integration/delete-selection", selection, { casOrganizationIntegrationId, selectAll });
        await wait(1000);
        return res.body;
    }
}
